export function handleNil(value: any, formatter?: (value: any) => any, replacer?: any): any {
    if (value == null) {
        return replacer || '—';
    }

    return formatter ? formatter(value) : value;
}
